import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// PrimeNG Modules
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from "primeng/multiselect";
import {TreeSelectModule} from "primeng/treeselect";
import {InputNumberModule} from "primeng/inputnumber";
import {CardModule} from "primeng/card";

@NgModule({
    imports: [
        CommonModule,
        TableModule,
        ButtonModule,
        DialogModule,
        DropdownModule,
        InputTextModule,
        CalendarModule,
        CheckboxModule,
        MultiSelectModule,
        TreeSelectModule,
        InputNumberModule,
        CardModule
    ],
    exports: [
        TableModule,
        ButtonModule,
        DialogModule,
        DropdownModule,
        InputTextModule,
        CalendarModule,
        CheckboxModule,
        MultiSelectModule,
        TreeSelectModule,
        InputNumberModule,
        CardModule
    ]
})
export class PrimengModule { }
